import React from 'react'
import styled from 'styled-components'
import { useRouter } from 'next/router'
import { useGetUsers } from 'src/hooks/users/useGetUsers'

export const CreatorProfilesSection = ({ excludeUserId = null }) => {
  const router = useRouter()
  const { users, isLoading } = useGetUsers({ creator: true, limit: 30 })

  if (isLoading) return <p className="text-sm text-gray-500">Loading creators...</p>

  const filteredUsers = excludeUserId
    ? users.filter((user) =>
        user.id !== excludeUserId &&
        user.profile?.avatar &&
        user.username
        )
    : users.filter(user => user.profile?.avatar && user.username);

  if (!filteredUsers.length) return null

  return (
    <section className="mt-8">
      <h2 className="font-soehne-kraftig text-xl tracking-tight mb-4">Meet More Creators</h2>
      <ScrollContainer>
        {filteredUsers.map((user) => (
          <UserCard key={user.id} className="cursor-pointer" onClick={() => router.push(`profile/${user.username}`)}>
            <Avatar src={user.profile?.avatar} alt={user.username} />
            <Username>{user.username}</Username>
          </UserCard>
        ))}
      </ScrollContainer>
    </section>
  )
}

const ScrollContainer = styled.div`
  display: flex;
  gap: 1.5rem; /* space-x-6 */
  overflow-x: auto;
  padding: 1rem 0;

  /* Hide scrollbar for Firefox */
  scrollbar-width: none;
  -ms-overflow-style: none;

  /* Hide scrollbar for Chrome, Safari and Opera */
  &::-webkit-scrollbar {
    display: none;
  }
`

const UserCard = styled.div`
  flex-shrink: 0;
  width: 104px; /* slightly wider to fit bigger avatar */
  display: flex;
  flex-direction: column;
  align-items: center;
`

const Avatar = styled.img`
  width: 80px;
  height: 80px;
  border-radius: 50%;
  object-fit: cover;
  border: 1px solid #d1d5db; /* Tailwind gray-300 */
`

const Username = styled.span`
  margin-top: 0.5rem;
  font-size: 0.75rem;
  font-weight: 600;
  text-align: center;
  width: 100%;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`
